// extracted by mini-css-extract-plugin
export default {"primaryColor":"#674ea7","secondaryColor":"#351c75","darkColor":"#1a0d3a","extraDarkColor":"#0c061d"};